import React from 'react';
import { Button, Result, Spin } from 'antd';
import { useParams } from 'react-router';
import { FormComponentProps } from '@ant-design/compatible/es/form';
import { Link, useHistory } from 'react-router-dom';
import UserStore from '../../stores/UserStore';
import { ErrorRender } from '@partsbadger/library';
import Verify from '../../components/Verify';
import NoContactRelatedAlert from '../../components/NoContactRelatedAlert';
import { observer } from 'mobx-react';
import SalesOrderStore from '../../stores/SalesOrderStore';

type Props = FormComponentProps;

const OrderNow = (props: Props) => {
    const params = useParams();
    const history = useHistory();

    //@ts-ignore
    const { quote_number } = params;
    const contact = UserStore.user?.default_contact?.id;
    const [error, setError] = React.useState<any>(null);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    /**
     * Check if is logged in and redirect to the checkout page
     */
    React.useEffect(() => {
        if (contact) {
            setIsLoading(true);
            SalesOrderStore.createOrderDraft({ contact: contact, quotes: [quote_number] })
                .then(order => {
                    history.replace(`/my-account/orders/checkout/${order.id}/`);
                })
                .catch(err => {
                    if (err.response && err.response.status === 406 && err.response.data.quote) {
                        history.replace(`/my-account/quotes/${err.response.data.quote}`);
                    } else {
                        setError(err);
                    }
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
    }, [quote_number, contact]);

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    return (
        <div>
            {isLoading && (
                <div className={'flex flex-row items-center justify-center'}>
                    <Spin tip={'Redirecting...'} />
                </div>
            )}

            {!isLoading && (
                <div>
                    <Result
                        status="403"
                        title="Something went wrong!"
                        subTitle={
                            <div>
                                <ErrorRender error={error} />
                                {!contact && <NoContactRelatedAlert />}
                            </div>
                        }
                        extra={
                            <Button>
                                <Link to="/my-account">Back to Home</Link>
                            </Button>
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default observer(OrderNow);
